export enum UxMessageType {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  CONFIRMATION = 'confirmation',
  CONSENT = 'consent',
  SUCCESS = 'success',
  PROMPT = 'prompt'
}
export interface IUxMessageOptions {
  okButton?:string;
  cancelButton?: string,
  callbackWithInfo?: (returnInfo: any) => void,
  returnInfo?: any;
  link?:string;
  consentString?: string;
  title?:string,
  icon?:string,
  inputType?:string,
  inputLabel?:string
}
export class UxMessage {
  /*Factory Methods*/
  public static infoType(message: string, stack?: string, options ?: IUxMessageOptions): UxMessage {
    return UxMessage.init(UxMessageType.INFO, message, stack, undefined, options);
  }

  public static warningType(message: string, stack?: string, options ?: IUxMessageOptions): UxMessage {
    return UxMessage.init(UxMessageType.WARNING, message, stack, undefined, options);
  }

  public static errorType(message: string, stack?: string,options ?: IUxMessageOptions): UxMessage {
    return UxMessage.init(UxMessageType.ERROR, message, stack, undefined, options);
  }

  public static successType(message: string, stack?: string,options ?: IUxMessageOptions): UxMessage {
    return UxMessage.init(UxMessageType.SUCCESS, message, stack, undefined, options);
  }

  public static confirmationType(message: string, callback?: (response: string) => void , options ?: IUxMessageOptions): UxMessage {
    return UxMessage.init(UxMessageType.CONFIRMATION, message, undefined, callback, options)
  }
  public static promptType(message: string, callback?: (response: string) => void , options ?: IUxMessageOptions): UxMessage {
    return UxMessage.init(UxMessageType.PROMPT, message, undefined, callback, options)
  }
  public static consentType(message: string, callback?: (response: string) => void , options ?: IUxMessageOptions): UxMessage {
    return UxMessage.init(UxMessageType.CONSENT, message, undefined, callback, options)
  }

  private static init(type: UxMessageType, message: string,  stack?: string, callback?: (response: string) => void , options : IUxMessageOptions = null): UxMessage {
    const item = new UxMessage(type, message, stack, callback);
    if (options) item.options = options;
    return item;
  }

  private _type: UxMessageType;
  private _messsage: string;
  private _stack: string;
  private _options: IUxMessageOptions;
  private _callback: (response: string) => void;

  constructor(type: UxMessageType, message: string, stack?: string, callback?: (r: string) => void) {
    this.type = type;
    this.message = message;
    this.stack = stack || '';
    this._callback = callback;
  }

  public get type(): UxMessageType {
    return this._type;
  }

  public set type(type: UxMessageType) {
    this._type = type;
  }

  public get message(): string {
    return this._messsage;
  }

  public set message(message: string) {
    this._messsage = message;
  }

  public get options():  IUxMessageOptions {
    return this._options;
  }

  public set options(options : IUxMessageOptions) {
    this._options = options;
  }

  public get stack(): string{
    return this._stack;
  }

  public set stack(stack: string) {
    this._stack = stack;
  }

  public Ok() {
    if (this._callback) this._callback('ok');
    if (this.options && this.options.callbackWithInfo) this.options.callbackWithInfo(this.options.returnInfo);
  }

  public Cancel() {
    if (this._callback) this._callback('cancel');
  }

}

